export default function legend(config) {
    return {
        display: false,
    };
}
